import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  card: {
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
  visitsNumberContainer: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    paddingBottom: theme.spacing(1),
  },
  progressSection: {
    marginBottom: theme.spacing(1),
  },
  progressTitle: {
    marginBottom: theme.spacing(2),
  },
  progress: {
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  pieChartLegendWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    marginRight: theme.spacing(1),
  },
  legendItemContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  fullHeightBody: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  tableWidget: {
    overflowX: "auto",
  },
  progressBar: {
    backgroundColor: theme.palette.warning.main,
  },
  performanceLegendWrapper: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  legendElement: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  legendElementText: {
    marginLeft: theme.spacing(1),
  },
  serverOverviewElement: {
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
  },
  serverOverviewElementText: {
    minWidth: 145,
    paddingRight: theme.spacing(2),
  },
  serverOverviewElementChartWrapper: {
    width: "100%",
  },
  mainChartBody: {
    overflowX: "auto",
    overflowY: "auto",
    minHeight: '1000px',
    height:'100%'
  },
  mainChartHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.only("xs")]: {
      flexWrap: "wrap",
    },
  },
  mainChartHeaderLabels: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.only("xs")]: {
      order: 3,
      width: "100%",
      justifyContent: "center",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
  },
  mainChartHeaderLabel: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(3),
  },
  mainChartSelectRoot: {
    borderColor: theme.palette.text.hint + "80 !important",
  },
  mainChartSelect: {
    padding: 10,
    paddingRight: 25,
  },
  mainChartLegentElement: {
    fontSize: "18px !important",
    marginLeft: theme.spacing(1),
  },
  hide: {
    display: 'hidden'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  filter: {
    marginTop: '16px'
  },
  chartTooltip: {
   backgroundColor: '#fff',
   border: '1px solid #ccc',
   padding: theme.spacing(1),
   borderRadius: theme.shape.borderRadius,
   boxShadow: theme.shadows[5],
   overflow: 'visible',
 },
 chartTooltipLabel: {
   fontWeight: 'bold'
 },
 chartTooltipTable: {
  display: 'flex',
  flexDirection: 'column'
  },
  chartTooltipCellHeader: {
  fontWeight: 'bold',
  padding: '5px',
  borderBottom: '1px solid #ccc',
},
  chartTooltipRow: {
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   marginBottom: '5px',
   '& > :first-child': {
    // width: '250px',
     fontWeight: 'bold',
     flex: '0 0 220px'
   },
   '& > :not(:first-child)': {
     flex: 1,
   }
 },
 chartTooltipCell: {
  marginRight: '10px',
},
filters: {
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
},
filterRight: {
  display:'flex',
  justifyContent: 'flex-end'
},
filterCenter: {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  alignItems: 'baseline',
  '& > div': {
    margin: '0 10px'
  }
}

}));
